import React, { useMemo } from 'react'
import { useEffect, useRef, useState } from 'react'
import { useRecoilState, useRecoilValue } from 'recoil'
import { API_URLS } from '@/src/constants/apis'
import { langModelState, langModelListState } from '@/store/langModel'
import { isShowMenu } from '@/store/common'
import { useRouter } from 'next/router'

const MENU_COUNT = 5 // 서버 메뉴 3개, 자체 메뉴 2개

const SideBar = React.memo(({}) => {
  const router = useRouter()
  const { pathname, query } = router // currentPath와 query를 추출
  const [currentPath, setCurrnetPath] = useState(router.pathname)
  const [subMenuVisibility, setSubMenuVisibility] = useState(
    Array.from({ length: MENU_COUNT }, () => false),
  )
  const [isMenuShow, setIsMenuShow] = useRecoilState(isShowMenu)
  const [langModel, setLangModel] = useRecoilState(langModelState)
  const langModelList = useRecoilValue(langModelListState)
  const extendedMenuList = useMemo(() => {
    return [
      ...langModelList,
      {
        title: 'GenAI 아티클 형식변환',
        code: 'article',
        Ver: '1.0',
        list: [
          {
            addr: '',
            name: '모델별 테스트',
            desc: 'Model Test',
          },
          {
            addr: '',
            name: '모델별 테스트 (프롬프트)',
            desc: 'Model Test (Prompt)',
          },
        ],
      },
      {
        title: 'Espresso 콘텐트 구성',
        code: 'espresso',
        Ver: '1.0',
        list: [
          {
            addr: '',
            name: '외부기사 요약',
            desc: 'Article Summary',
          },
          {
            addr: '',
            name: '외부기사 비교',
            desc: 'Article Comparision',
          },
        ],
      },
      {
        title: 'GenAI 모델 테스트',
        code: 'extra',
        Ver: '1.0',
        list: [
          {
            addr: '',
            name: '제목생성',
            desc: 'Article Title Generation'
          },
          {
            addr: '',
            name: '시리즈 페이월 구독 문구생성',
            desc: 'Plus Series Paywall Text'
          },
          {
            addr: '',
            name: '시리즈 페이월 요약',
            desc: 'Plus Series Paywall Summary'
          },
          {
            addr: '',
            name: '트렌드 키워드',
            desc: 'Article Trend Keywords'
          },
        ]
      },
    ]
  }, [langModelList])
  const sideBarShadowRef = useRef(null)

  useEffect(() => {
    loadSummarizationModel()
  }, [])

  const loadSummarizationModel = async () => {
    const response = await fetch(API_URLS.MODEL_VERTEXAI_PARM3_MODEL_LIST, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })

    const data = await response.json()
    setLangModel(data)
  }

  const handleLinkClick = (event, urlLink) => {
    event.preventDefault()
    setIsMenuShow(!(window.innerWidth <= 1024))

    router.push(urlLink)
  }

  const toggleMainSidebar = () => {
    setIsMenuShow(!isMenuShow)
  }

  const toggleAccordionMenuSidebar = (index) => {
    setSubMenuVisibility((prevState) => {
      const updatedState = [...prevState]
      updatedState[index] = !updatedState[index]
      return updatedState
    })
  }

  const closeMenuOnOutsideClick = (event) => {
    if (
      sideBarShadowRef.current &&
      sideBarShadowRef.current.contains(event.target)
    ) {
      setIsMenuShow(!(window.innerWidth <= 1024))
    }
  }

  useEffect(() => {
    if (!extendedMenuList || extendedMenuList.length === 0) return

    setSubMenuVisibility((prev) => {
      const len = extendedMenuList.length
      const safePrev = prev.length === len ? prev : Array(len).fill(false)

      return extendedMenuList.map((menu, i) => {
        const wasOpen = safePrev[i]
        const isCurrentSection = !!menu?.code && currentPath.includes(menu.code)
        return wasOpen || isCurrentSection // OR 머지: 기존 true 유지 + 현재 섹션 추가로 true
      })
    })
    // const initialMenuVisibility = extendedMenuList.map((model) =>
    //   currentPath.includes(model.code)
    // );
    // setSubMenuVisibility(initialMenuVisibility);
  }, [currentPath, extendedMenuList])

  useEffect(() => {
    console.log('[Sidebar] mounted');
    return () => console.log('[Sidebar] unmounted');
  }, []);

  useEffect(() => {
    setIsMenuShow(!(window.innerWidth <= 1024))

    const handleResize = () => {
      setIsMenuShow(!(window.innerWidth <= 1024))
    }

    // 처음 컴포넌트가 마운트될 때 resize 이벤트 리스너를 추가
    window.addEventListener('resize', handleResize)

    // 컴포넌트가 언마운트될 때 resize 이벤트 리스너를 제거 (메모리 누수 방지)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    setCurrnetPath(router.pathname)
    console.log('currentPath', router.pathname)
  }, [router.pathname])

  useEffect(() => {
    // 전역 click 이벤트 리스너를 추가하여 메뉴 영역 외부를 클릭할 때 메뉴를 닫습니다.
    document.addEventListener('click', closeMenuOnOutsideClick)

    // 컴포넌트가 언마운트될 때 click 이벤트 리스너를 제거합니다.
    return () => {
      document.removeEventListener('click', closeMenuOnOutsideClick)
    }
  }, [])

  return (
    <aside
      id="sidebar"
      className={`sidebar ${isMenuShow ? 'show' : 'hide'}`}
      style={{}}
    >
      <div className="header">
        <button
          type="button"
          className="btn_navigation"
          onClick={toggleMainSidebar}
        >
          <i className="ico_navigation"></i>
        </button>
        <strong>JoongAng AI</strong>
      </div>
      <nav className="nav">
        {extendedMenuList &&
          extendedMenuList.map((item, outerIndex) => {
            // console.log('path test', outerIndex, currentPath.includes(item.code))
            return (
              <dl
                key={outerIndex}
                id={`accordion${outerIndex}`}
                className={subMenuVisibility[outerIndex] ? 'show' : ''}
              >
                <dt>
                  <button
                    id="toggleButton2"
                    type="button"
                    onClick={() => toggleAccordionMenuSidebar(outerIndex)}
                    aria-controls="accordion"
                    aria-expanded={subMenuVisibility[outerIndex]}
                  >
                    {item.title} <i className="ico_arrow"></i>
                  </button>
                </dt>
                {item?.list &&
                  item.list.map((subItem, innerIndex) => {
                    const segments = pathname.split('/') // 경로를 '/' 기준으로 나눔

                    const isActive =
                      currentPath.includes(item.code) &&
                      Number(query.id) === innerIndex + 1 // subMenuVisibility[innerIndex] // menuVisibility 배열에서 해당 index 값 가져오기

                    return (
                      <dd
                        key={`${outerIndex}_${innerIndex}`}
                        className={isActive ? 'active' : ''}
                      >
                        <a
                          href={`/langai/${item.code}/${innerIndex + 1}`}
                          onClick={(e) =>
                            handleLinkClick(
                              e,
                              `/langai/${item.code}/${innerIndex + 1}`,
                            )
                          }
                        >
                          {subItem.name}
                        </a>
                      </dd>
                    )
                  })}
              </dl>
            )
          })}

        {/*<dl>*/}
        {/*  <dt className="fav">*/}
        {/*    <a href="#">즐겨찾기</a>*/}
        {/*  </dt>*/}
        {/*  <dt className="ai">*/}
        {/*    <a href="#">AI 히스토리</a>*/}
        {/*  </dt>*/}
        {/*</dl>*/}
      </nav>
      <span className="shadow" aria-hidden="true" ref={sideBarShadowRef}></span>
    </aside>
  )
})

export default SideBar
